import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { applyBrandedPdfChrome, exportNodeAsBrandedPNG } from '../../branding/exportBranding';

const tableHeaders = ['Serial Number', 'PASS Count', 'FAIL Count', 'STOP Count', 'UNCOMPLETE Count'];

const toTableRows = (rows) => rows.map((data) => [
    data.serialNumber,
    data.passCount,
    data.failCount,
    data.stopCount,
    data.uncompleteCount,
]);

export const exportStatusChartAsPNG = async (chartNode) => {
    if (!chartNode) return;

    await exportNodeAsBrandedPNG(chartNode, 'uut-status-summary-chart');
};

export const exportStatusTableAsCSV = (rows) => {
    if (!rows.length) return;

    const csvContent = [tableHeaders, ...toTableRows(rows)].map((row) => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'uut_status_summary.csv');
};

export const exportStatusTableAsPDF = (rows) => {
    if (!rows.length) return;

    const doc = new jsPDF();
    doc.text('UUT Status Summary', 14, 15);
    doc.autoTable({
        head: [tableHeaders],
        body: toTableRows(rows),
        startY: 20,
    });
    applyBrandedPdfChrome(doc, { title: 'UUT Status Summary' });
    doc.save('uut_status_summary.pdf');
};
